<input hidden [value]="(selectedItem$ | async)?.getSelectionTitle()" [attr.id]="controlId" [attr.name]="name" />

<!-- Desktop -->
<div
  #desktopDropdown
  [hidden]="isMobile$ | async"
  class="reactive-form-input reactive-form-html-dropdown"
  role="combobox"
  aria-haspopup="listbox"
  [attr.aria-labelledby]="labelId"
  [attr.aria-expanded]="!!(showDropdown$ | async)"
  [class.review-input-error-border]="error"
  [class.disabled]="disabled"
  [class.dropdown-open]="showDropdown$ | async"
  [class.placeholder-selected]="!!(selectedItem$ | async)"
  (click)="toggleDropdown()"
  [attr.contenteditable]="false"
  tabindex="0">
  {{ (selectedItem$ | async)?.getSelectionTitle() || placeholder }}
</div>

<div class="dropdown-content" [hidden]="!(showDropdown$ | async) || isMobile" #dropdownContent>
  <div
    class="dropdown-item clearable"
    *ngIf="clearable && !disabled && (selectedItem$ | async)"
    (click)="resetInput(); closeDropdown()"
    [class.highlighted]="clearable && highlightedIndex === 0"
    i18n>
    Reset
  </div>
  <div
    class="dropdown-item"
    *ngFor="let item of dropdowns; let i = index"
    (click)="itemSelected(item)"
    [class.disabled]="item.getSelectionIsDisabled()"
    [class.selected]="item.getSelectionValue() === (selectedItem$ | async)?.getSelectionValue()"
    [class.highlighted]="i === highlightedIndex - (clearable && !disabled && (selectedItem$ | async) ? 1 : 0)">
    <img
      *ngIf="item.getSelectionValue() === (selectedItem$ | async)?.getSelectionValue() as selected"
      class="icon-img"
      src="assets/icons/typeahead/Check.svg" />
    {{ item.getSelectionTitle() }}
  </div>
</div>

<!-- Mobile -->
<select
  *ngIf="isMobile$ | async"
  class="reactive-form-input reactive-form-html-dropdown"
  [attr.aria-labelledby]="labelId"
  [class.review-input-error-border]="error"
  [disabled]="disabled"
  [value]="(selectedItem$ | async)?.getSelectionValue() ?? ''"
  [ngClass]="{ 'placeholder-selected': !(selectedItem$ | async)?.getSelectionValue() }"
  (change)="onSelectChanged($event)">
  <option value="" disabled>
    {{ placeholder }}
  </option>
  <option *ngFor="let drop of dropdowns" [value]="drop.getSelectionValue()" [disabled]="drop.getSelectionIsDisabled()">
    {{ drop.getSelectionTitle() }}
  </option>
</select>
